import { APPID, APPVERSION } from "../common/globals";
import { BASE_AXIOS } from "../config";

export const apiFetchAvailableQuestions = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("yearvar", data.yearvar);
    form.append("gamemode", data.gamemode);
    form.append("areavar", data.areavar);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get available questions');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 
    
    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getQuestionAccess"
            },
            data: form
        });

        return response.data[0];
    } catch (error) {
        throw error;
    }
};


